import {
  DRAWER_HOME_SCREEN_ZONE_BUTTON_CLICK_EVENT,
  DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT,
  CONCAT_TEXT_LIMIT,
  HEADER_TAB_SETUP,
} from "../../functions/funtion";
import {
  SET_STORE_CUSTOMER_DEFAULT_ADDRESS,
  SET_STORE_CUSTOMER_ADDRESSLIST,
  SET_STORE_DELIVERYZONEID,
} from "../../database/store-data";
import {
  dto_CustomerAddressList,
  dto_CustomerAddress,
  dto_Customer,
} from "../../classes/dto-customer";
import {
  api_SaveCustomerDeliveryAddress,
  api_GetCustomerDeliveryAddress,
} from "../../connection/api/api-profile";
import { STORE_dtoCustomerAddressList } from "../../database/store-names";
import { CSP, ENCRYPT_STORAGE } from "../../config/config";
import { GET_STARTING_NO } from "../../database/get-stored-data";
import { PT_ADDRESSLIST } from "../../routes/stack/paths/pt-profile";
import { dto_common } from "../../classes/dto-common";
import { F_Fammily } from "../../util/config-fonts";
import { PT_HOME } from "../../routes/stack/paths/pt-home";
import { Colors } from "../../util/colors";
import { Font } from "../../util/config-fonts";
import RENDER_DRAWER_ZONE from "../../components/render-drawer-zone/render-drawer-zone";
import DrawerSheetBottom from "../../components/BottomDrawer/drawer-bottom";
import GoogleMapComponent from "../../components/google-map/google-map";
import React from "react";
import Alert from "../../components/Alert";
import "../../styles/css/pg-profile-addnew-address.css";
import "../../styles/css/pg-profile-register.css";
import { ToastMessage } from "../../components/toast-notification/toast";
import { resolveAddressPhoneNo } from "../../functions/address-phone";

export default class ADDNEWADDRESS extends React.Component {
  constructor(props) {
    super(props);
    this.add1Ref = React.createRef();
    this.add2Ref = React.createRef();
    this.add3Ref = React.createRef();
    this.state = {
      isActive: false,
      value: "",
      phoneNumber: "",
      ZoneModelOpen: false,
      StartingNo: "",
      isActivePhoneNo: false,
      isActiveAdd1: false,
      isActiveAdd2: false,
      isActiveAdd3: false,
      isActiveName: false,
      Add1: "",
      Add2: "",
      Add3: "",
      IsLoading: false,
      LocationCordinates: "0,0",
      hasZoneBeenSelected: false,
    };
    this.handleInputChangePhoneNo = this.handleInputChangePhoneNo.bind(this);
  }

  async componentDidMount() {
    await HEADER_TAB_SETUP({
      HeaderTabName: CONCAT_TEXT_LIMIT({
        length: 20,
        string: "New Address",
      }),
      FnGoBackScreen: () => {
        this.props.navigate(PT_ADDRESSLIST);
      },
      HeaderNavigatorMenuDisplay: false,
      FnHeaderNavigatorMenu: () => {},
    });
    DRAWER_HOME_SCREEN_ZONE_BUTTON_CLICK_EVENT(() => {
      this.setState({ ZoneModelOpen: false });
    });
    await DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT(() => {
      this.setState({ ZoneModelOpen: false });
    });
    this.setState({ StartingNo: await GET_STARTING_NO() });
  }

  async SaveCustomerDeliveryAddress() {
    var add1 = this.state.Add1;
    var add2 = this.state.Add2;
    var add3 = this.state.Add3;
    var ZoneID = dto_common.ZoneId;
    var cordinates = this.state.LocationCordinates;
    if (add1 === "") {
      Alert.MessageBox({
        Tittle: "Field Required",
        Icon: "warning",
        ConfirmButtonText: "ok",
        Text: CSP === "AV" ? " Address No | floor" : " Address No ",
        ConfirmButtonFunction: () => {
          const add1Input = this.add1Ref.current;
          add1Input.style.backgroundColor = "rgb(245, 245, 136)";
        },
      });
      return;
    }
    if (add2 === "") {
      Alert.MessageBox({
        Tittle: "Field Required",
        Icon: "warning",
        ConfirmButtonText: "ok",
        Text: CSP === "AV" ? "Magu" : "Street Name",
        ConfirmButtonFunction: () => {
          const add2Input = this.add2Ref.current;
          add2Input.style.backgroundColor = "rgb(245, 245, 136)";
        },
      });
      return;
    }
    if (add3 === "") {
      Alert.MessageBox({
        Tittle: "Field Required",
        Icon: "warning",
        ConfirmButtonText: "ok",
        Text: CSP === "AV" ? "Land Mark | Goalhi" : "Land Mark",
        ConfirmButtonFunction: () => {
          const add3Input = this.add3Ref.current;
          add3Input.style.backgroundColor = "rgb(245, 245, 136)";
        },
      });
      return;
    }
    if (ZoneID === "" || ZoneID === 0) {
      ToastMessage(1, "Please select the zone");

      return;
    }
    if (cordinates === "0,0" || cordinates === "") {
      ToastMessage(1, "Please pick select your location");

      return;
    }

    this.setState({ IsLoading: true });
    let data = await api_SaveCustomerDeliveryAddress(
      add1,
      add2,
      add3,
      dto_Customer.CusName,
      this.state.phoneNumber,
      ZoneID,
      cordinates,
    );
    let objData = JSON.parse(data);
    let objobjData = JSON.parse(objData);

    dto_CustomerAddress.DefaultAdd1 = objobjData[0][0].Add1;
    dto_CustomerAddress.DefaultAdd2 = objobjData[0][0].Add2;
    dto_CustomerAddress.DefaultAdd3 = objobjData[0][0].Add3;
    dto_CustomerAddress.AddressGuid = objobjData[0][0].GUID;
    dto_CustomerAddress.PhoneNo = resolveAddressPhoneNo(
      objobjData[0][0],
      this.state.phoneNumber,
    );
    dto_CustomerAddress.Location = objobjData[0][0].Location;
    await SET_STORE_CUSTOMER_DEFAULT_ADDRESS();

    dto_common.DeliveryZoneID = objobjData[0][0].DeliveryZoneID;
    await SET_STORE_DELIVERYZONEID(objobjData[0][0].DeliveryZoneID);
    ENCRYPT_STORAGE.removeItem(STORE_dtoCustomerAddressList);

    let dataAddress = await api_GetCustomerDeliveryAddress();
    let objDataAddress = JSON.parse(dataAddress);
    let objobjDataAddress = JSON.parse(objDataAddress);
    if (objobjDataAddress[0].length > 0) {
      dto_CustomerAddressList.dtoAddressList = objobjDataAddress[0];
      await SET_STORE_CUSTOMER_ADDRESSLIST();
    }
    this.setState({ IsLoading: false });
    this.props.navigate(PT_HOME);
  }

  handleInputChangePhoneNo(text) {
    this.setState({ phoneNumber: text });
    if (text !== "") {
      this.setState({ isActivePhoneNo: true });
    } else {
      this.setState({ isActivePhoneNo: false });
    }
  }

  handleInputChangeName(text) {
    this.setState({ value: text });
    if (text !== "") {
      this.setState({ isActiveName: true });
    } else {
      this.setState({ isActiveName: false });
    }
  }

  handleTextChangeAdd1(text) {
    this.setState({ Add1: text });
    if (text !== "") {
      this.setState({ isActiveAdd1: true });
    } else {
      this.setState({ isActiveAdd1: false });
    }
  }

  handleTextChangeAdd2(text) {
    this.setState({ Add2: text });
    if (text !== "") {
      this.setState({ isActiveAdd2: true });
    } else {
      this.setState({ isActiveAdd2: false });
    }
  }

  handleTextChangeAdd3(text) {
    this.setState({ Add3: text });
    if (text !== "") {
      this.setState({ isActiveAdd3: true });
    } else {
      this.setState({ isActiveAdd3: false });
    }
  }

  render() {
    const {
      Add1,
      Add2,
      Add3,
      phoneNumber,
      isActiveAdd1,
      isActiveAdd2,
      isActiveAdd3,
      isActivePhoneNo,
    } = this.state;
    const isDTMK = CSP === "DT" || CSP === "MK";
    const add1Label =
      CSP === "AV" ? " Address No | floor" : isDTMK ? "Address Number" : " Address No ";
    const add2Label = CSP === "AV" ? "Magu" : "Street Name";
    const add3Label = CSP === "AV" ? "Land Mark | Goalhi" : "Land Mark";
    const phoneLabel = isDTMK ? "Phone Number" : "Phone No";
    return (
      <div
        style={{
          height: "100vh",
        }}
      >
        <div className="addNewLayout fadeInUp animated">
          {/* Address 1 */}
          <div className="float-label">
            <input
              ref={this.add1Ref}
              id="Add1"
              value={Add1}
              maxLength={25}
              onChange={(e) => {
                this.handleTextChangeAdd1(e.currentTarget.value);
                e.currentTarget.style.backgroundColor = "";
              }}
              onBlur={(e) => (e.currentTarget.style.backgroundColor = "")}
            />
            <label className={isActiveAdd1 ? "Active" : ""}>{add1Label}</label>
          </div>

          {/* Address 2 */}
          <div className="float-label">
            <input
              ref={this.add2Ref}
              id="Add2"
              value={Add2}
              maxLength={25}
              onChange={(e) => {
                this.handleTextChangeAdd2(e.currentTarget.value);
                e.currentTarget.style.backgroundColor = "";
              }}
              onBlur={(e) => (e.currentTarget.style.backgroundColor = "")}
            />
            <label className={isActiveAdd2 ? "Active" : ""}>{add2Label}</label>
          </div>

          {/* Address 3 */}
          <div className="float-label">
            <input
              ref={this.add3Ref}
              id="Add3"
              value={Add3}
              maxLength={25}
              onChange={(e) => {
                this.handleTextChangeAdd3(e.currentTarget.value);
                e.currentTarget.style.backgroundColor = "";
              }}
              onBlur={(e) => (e.currentTarget.style.backgroundColor = "")}
            />
            <label className={isActiveAdd3 ? "Active" : ""}>{add3Label}</label>
          </div>

          {/* Phone No */}
          <div className="float-label">
            {!isDTMK ? (
              <div
                style={{
                  backgroundColor: "#f2f2f2",
                  marginTop: 8,
                  marginBottom: 0,
                  marginRight: 3,
                  padding: "10px",
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "center",
                  borderRadius: "4px",
                }}
              >
                <p style={{ margin: 0, fontFamily: F_Fammily.Regular }}>
                  {this.state.StartingNo}
                </p>
              </div>
            ) : null}
            <input
              id="phoneNo"
              type="text"
              inputMode="numeric"
              maxLength={10}
              value={phoneNumber}
              onChange={(e) =>
                this.handleInputChangePhoneNo(
                  e.currentTarget.value.replace(/[^0-9]/g, ""),
                )
              }
            />
            <label
              style={!isDTMK ? { marginLeft: 64 } : undefined}
              className={isActivePhoneNo ? "Active" : ""}
            >
              {phoneLabel}
            </label>
          </div>

          {/* Pick Zone */}
          <div className="inputSet">
            <button style={{ display: "none" }} id="ZoneID">
              {" "}
              {dto_common.ZoneId}
            </button>

            <button
              style={{
                width: "100%",
                marginTop: "20px",
                height: "45px",
                fontSize: Font.Heading,
                border: "none",
                borderRadius: CSP === "DT" || CSP === "MK" ? "8px" : "4px",
                cursor: "pointer",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#f1f1f1",
              }}
              onClick={() => {
                this.setState({ ZoneModelOpen: true });
              }}
            >
              {this.state.hasZoneBeenSelected
                ? dto_common.ZoneDescription
                : "Please select the Zone"}
              <i
                className="bi bi-caret-down-fill"
                style={{
                  marginLeft: 5,
                  marginRight: 5,
                  color: Colors.DarkGreyScale,
                  fontSize: "14px",
                }}
              ></i>
            </button>
          </div>

          {/* Google Map */}

          <GoogleMapComponent
            OnMarkerChange={(e) => {
              dto_common.CurrentCordinate = e.lat + "," + e.lng;
              this.setState({
                LocationCordinates: e.lat + "," + e.lng,
              });
            }}
            Zoom={18}
          />

          {/* Submit Button */}
          <div className="addNewBtn">
            <button
              style={{
                backgroundColor: Colors.DarkGreyScale,
                fontFamily: F_Fammily.Medium,
                cursor: "pointer",
                width: "100%",
                height: "48px",
              }}
              onClick={() => this.SaveCustomerDeliveryAddress()}
              disabled={this.state.IsLoading}
            >
              Save{"  "}
              {this.state.IsLoading ? (
                <i className="fa fa-circle-o-notch fa-spin"></i>
              ) : (
                ""
              )}
            </button>
          </div>
        </div>

        <DrawerSheetBottom
          open={this.state.ZoneModelOpen}
          displayCloseIcon="block"
          Heading="SELECT ZONE"
          element={
            <RENDER_DRAWER_ZONE
              SelectZone={async (rs) => {
                dto_common.ZoneId = rs.PID;
                dto_common.ZoneDescription = rs.Description;
                this.setState({
                  ZoneModelOpen: false,
                  hasZoneBeenSelected: true,
                });
              }}
            />
          }
        />
      </div>
    );
  }
}
